<template>
  <BaseButton :variant="variant" @click="$emit('click')">
    <BaseIcon
      v-if="isShowIcon"
      icon-name="redemptionStatus"
      :width="iconWidth"
      :height="iconHeight"
    >
      <IconRedemptionStatus></IconRedemptionStatus>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconRedemptionStatus from '@/components/icon/IconRedemptionStatus.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconRedemptionStatus,
  },
  props: {
    variant: { type: String, default: 'outline-secondary' },
  },
};
</script>

<style lang="scss" scoped></style>
